module.exports = __webpack_public_path__ + "img/IMG_9674-3.42664d8e.png";